<template>
  <BaseFetchData :action="fetchData">
    <template #default="fetchDataProps">
      <div key="grid_view" class="p-4 space-y-4 bg-gray-100">
        <BaseGrid :columns="4" class="gap-4">
          <FacebookPagePostCard v-for="post in posts" :key="post.id" :post="post" />
        </BaseGrid>
        <div v-if="fetchDataProps.status.loading" class="text-center">
          <Loader />
        </div>
        <div v-if="cursor" class="text-center">
          <BaseButton primary outline @click="fetchDataProps.fetchData({ after: cursor })"
            >Load More</BaseButton
          >
        </div>
      </div>
    </template>
  </BaseFetchData>
</template>

<script>
import { accountFacebookPagePostsClient } from '@/api/clients';
import FacebookPagePostCard from './FacebookPagePostCard.vue';

export default {
  components: {
    FacebookPagePostCard,
  },
  props: {
    facebookPage: {
      type: Object,
      required: true,
    },
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      posts: [],
      cursor: null,
    };
  },
  methods: {
    fetchData(params) {
      return accountFacebookPagePostsClient
        .list(this.accountId, this.facebookPage.id, {
          ...params,
          fields:
            'id,story,message,created_time,full_picture,permalink_url,insights.metric(post_reactions_by_type_total)',
          ...(this.since ? { since: this.since } : {}),
          ...(this.until ? { until: this.until } : {}),
        })
        .then((response) => {
          this.posts = [...this.posts, ...response.data];
          this.cursor = response.cursor;
        });
    },
    loadMore() {
      return this.fetchData({ after: this.cursor });
    },
  },
};
</script>
